<template>
    <div id="ppanel-tool"
         class="ppanel-listing"
    >
        <div class="item"
            v-for="item in data.filteredList"
        >
            <a href="#"
               @click.prevent="openLink(item.link)"
            >
                <!--  TODO: i18n -->
                {{ item.chi_name }}
            </a>
        </div>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, inject}  from "vue";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {usePpanel}  from "@/modules/reader/ppanel/ppanel";
    import {appendAccessToken} from  "@/modules/utils/pathUtils";
    import axios from 'axios'
    import qs from "qs";
    import cssvar from '@/scss/_variables.scss';
    import {isTeacher, isStudent} from "@/modules/api/auth";

    export default {
        setup(props, context) {

            const i18n = inject('i18n')
            const { bookData} = useDataLoader();
            const {pPanelState} = usePpanel();

            const data = reactive({
                heading: i18n.t("label_tools"),
                filteredList:computed(()=>{

                    if (!bookData.tools) {
                        return [];
                    }

                    return bookData.tools.filter(el => {
                        if (isTeacher()) {
                            return (el["use_in"] === "T" || el["use_in"] === "B") && (el["platform"] === "web" ||  el["platform"] === "all")

                        } else if (isStudent()) {
                            return (el["use_in"] === "S" || el["use_in"] === "B") && (el["platform"] === "web" || el["platform"] === "all")
                        }
                    })
                })
            })

            const openLink = (src) => {
                window.open(appendAccessToken(src), "_blank");
            }

            onMounted(()=>{
                pPanelState.isToolEnabled =  data.filteredList.length > 0;
            })

            return {
                data,
                bookData,
                openLink
            }
        }

    }

</script>

<style scoped lang="scss">

</style>